<template>

  <div>
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">
          <label class="vs-input--label">{{$t('TelaPerfilCoresVelocidadePercurso_nome')}}</label>
          <vs-input class="mb-4 md:mb-0 w-full" v-model="filtroNome" />
        </vs-col>

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtroNome)"></vs-button>
          </vx-tooltip>
          <vx-tooltip :text="$t('LimparFiltros')">              
            <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
          </vx-tooltip>
          <vx-tooltip :text="$t('Novo')">              
            <vs-button class="mr-2" radius color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
          </vx-tooltip>
          <vx-tooltip :text="$t('ExportarParaCSV')">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vx-tooltip>
        </vs-col>
      </vs-row>
      
    </vx-card>

     <vx-card>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="27"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationAutoPageSize="true"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
          <div class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg flex items-center justify-between font-medium text-sm">
            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ dadosDaGrid.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : dadosDaGrid.length }} de {{ dadosDaGrid.length }}</span>              
          </div>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="text-sm" />
        </vs-col>
      </vs-row>
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"

import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'

const URL_SERVLET = "/rest/PerfilCoresVelocidadePercurso/Listar";
const NAME_ROUTE_EDIT = "configuracao-perfil-cores-edit";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      filtroNome: null,
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [                    
            { headerName: 'NOME', field: 'nome' },                   
            { headerName: 'Faixa 1', field: 'velocidadeFaixa1',  
              cellRenderer: function(params) {
                return '<div class="flex"> <div style="width: 20px; height: 20px; background-color:' + params.data.corFaixa1 + '; margin-right: 10px;"> </div> ' + params.data.velocidadeFaixa1Inicio + ' - ' + params.data.velocidadeFaixa1Fim + ' </div>';
              }
            },                   
            { headerName: 'Faixa 2', field: 'velocidadeFaixa2',
              cellRenderer: function(params) {
                return '<div class="flex"> <div style="width: 20px; height: 20px; background-color:' + params.data.corFaixa2 + '; margin-right: 10px;"> </div> ' + params.data.velocidadeFaixa2Inicio + ' - ' + params.data.velocidadeFaixa2Fim +  ' </div>';
              }, 

            },                   
            { headerName: 'Faixa 3', field: 'velocidadeFaixa3',
              cellRenderer: function(params) {
                return '<div class="flex"> <div style="width: 20px; height: 20px; background-color:' + params.data.corFaixa3 + '; margin-right: 10px;"> </div> ' + params.data.velocidadeFaixa3Inicio + ' - ' + params.data.velocidadeFaixa3Fim +  ' </div>';
              }, 
            
            },                   
            { headerName: 'Faixa 4', field: 'velocidadeFaixa4',
              cellRenderer: function(params) {
                if (params.data.velocidadeFaixa4Inicio || params.data.velocidadeFaixa4Fim) {
                  return '<div class="flex"> <div style="width: 20px; height: 20px; background-color:' + params.data.corFaixa4 + '; margin-right: 10px;"> </div> ' + params.data.velocidadeFaixa4Inicio + ' - ' + params.data.velocidadeFaixa4Fim +  ' </div>';
                } else {
                  return '';
                }
              }, 
            
            },                   
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0  
    }
  },  
  computed: {
    filterSectionHeight() {
      return 320;   
    },    
    paginationPageSize() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetPageSize()
      else return 200  
    },
    totalPages() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.configuracaoGrid.gridApi.paginationGoToPage(val - 1)
      }
    },    
  },
  methods: {
    limparFiltros() {
      this.filtroNome = null;      
    },
    fetchLista(pFiltroNome) {     
      this.$vs.loading();
      this.currentPage = 1; 
      const params = new URLSearchParams();      
      params.append('idCliente', this.$store.state.AppActiveUser.id);  
      params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);  
      
      params.append('pagina', -1);
      if (pFiltroNome) {
        params.append('nome', pFiltroNome);
      }

      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.$vs.loading.close();
              this.totalRegistros = response.data.Resultado.quantidade;
              if (response.data.Resultado.quantidade > 1) {
                  this.dadosDaGrid = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.dadosDaGrid = [];
                  this.dadosDaGrid.push(response.data.Resultado.lista.item);
              } else {
                  this.dadosDaGrid = [];
              }
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'DivisaoControleAcesso.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    this.fetchLista();
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 305px);
  }
</style>